// Minimal shim — server-side parsing is now in supabase/functions/invoice-parse
// This file is kept for type exports and the explainPlanHumanReadable helper only.

export type ParsedDoc = {
  amountAED: number | null;
  dueDate?: string;
  issuer?: string;
  lineItems?: Array<{ label: string; amountAED?: number }>;
  rawText?: string;
};

/**
 * @deprecated Use the invoice-parse edge function via InvoiceUpload component.
 * Client-side parsing is no longer allowed.
 */
export async function parseInvoiceOrQuote(_file: File): Promise<ParsedDoc> {
  throw new Error('Client-side invoice parsing is disabled. Use the InvoiceUpload component which calls the server-side parser.');
}

export function explainPlanHumanReadable(plan: {
  breakdown: { bnplAED?: number; bankFinanceAED?: number; upfrontAED?: number };
  tenureMonths?: number;
}): string {
  const b = plan.breakdown;
  const parts: string[] = [];
  if (b.bnplAED) parts.push(`BNPL ~ AED ${b.bnplAED.toLocaleString()}`);
  if (b.bankFinanceAED) parts.push(`Finance ~ AED ${b.bankFinanceAED.toLocaleString()}`);
  if (b.upfrontAED) parts.push(`Upfront ~ AED ${b.upfrontAED.toLocaleString()}`);
  return `${parts.join(" + ")}${plan.tenureMonths ? ` • ~${plan.tenureMonths} mo` : ""}`;
}
